import React, {useEffect} from 'react';
import {loadTimelineData} from 'anima-timeline';
import "./ContactUs.css";
import NavBar from "../NavBar";
import Footer from "../Footer";
import ContactUs from "../../Common/ContactUs";
//import {Link} from "react-router-dom";
import {contact} from "../../data";


function App() {
  return <X10ContactUsPageTablet {...x10ContactUsPageTabletData} />;
}

export default App;

function X10ContactUsPageTablet(props) {
  const {
    contactUs,
    rectangle76,
    rectangle99,
    sendAMessage,
    text112,
    //frame144Props,
    textInputsNormalProps,
    frame1650Props,
    textInputsNormal2Props,
    button2Props,
    //footer5Props,
  } = props;

  return (
    <div className="cpt-container-center-horizontal">
      <div className="cpt-x10-contact-us-page-tablet screen">
        {/* <Frame144 group86Props={frame144Props.group86Props} iconMenuProps={frame144Props.iconMenuProps} /> */}
        <NavBar/>
        <h1 className="cpt-title cpt-valign-text-middle cpt-typographyheadlineh4-extrabold-24">{contactUs}</h1>
        {/* <img className="cpt-rectangle-76" src={rectangle76} /> */}
        <img className="cpt-rectangle-76" src={contact.ContactHeader} alt="Webuildd Contact Us" />
        <iframe className="cpt-rectangle-99" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4758.027961564364!2d77.56739558617797!3d13.028810897148835!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1785808f1037%3A0x3e8b84d6688c5383!2sWebuildd!5e0!3m2!1sen!2sin!4v1632809494580!5m2!1sen!2sin"></iframe>
        {/* <img className="cpt-rectangle-99" src={rectangle99} /> */}
        <div className="cpt-send-a-message cpt-valign-text-middle cpt-typographyheadlineh4-extrabold-24">{sendAMessage}</div>
        <p className="cpt-text-1 cpt-typography-body-smalltext-14-regular">{text112}</p>
        <div className="cpt-frame-205">
          <div className="cpt-frame-1652">
            <ContactUs />
            {/* <TextInputsNormal20>{textInputsNormalProps.children}</TextInputsNormal20>
            <Frame1650
              textInputsNormal2Props={frame1650Props.textInputsNormal2Props}
              textInputsNormal22Props={frame1650Props.textInputsNormal22Props}
            />
            <TextInputsNormal22 className={textInputsNormal2Props.className}>
              {textInputsNormal2Props.children}
            </TextInputsNormal22> */}
          </div>
          {/*<Link>
            <Button23>{button2Props.children}</Button23>
          </Link> */}
        </div>
        
        {/* <Footer52 {...footer5Props} />*/}
        <Footer />
      </div>
    </div>
  );
}


function Frame144(props) {
  const { group86Props, iconMenuProps } = props;

  return (
    <div className="cpt-frame-144">
      <Group86 group85={group86Props.group85} whiteProps={group86Props.whiteProps} />
      <IconMenu vector2={iconMenuProps.vector2} vector3={iconMenuProps.vector3} />
    </div>
  );
}


function Group86(props) {
  const { group85, whiteProps } = props;

  return (
    <div className="cpt-group-86">
      <White src={whiteProps.src} />
      <img className="cpt-group-85" src={group85} />
    </div>
  );
}


function White(props) {
  const { src } = props;

  return (
    <div className="cpt-white">
      <img className="cpt-vector" src={src} />
    </div>
  );
}


function IconMenu(props) {
  const { vector2, vector3 } = props;

  return (
    <div className="cpt-icon-menu">
      <img
        className="cpt-vector-2"
        src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg"
      />
      <img className="cpt-vector-1" src={vector2} />
      <img className="cpt-vector-1" src={vector3} />
    </div>
  );
}


function TextInputsNormal20(props) {
  const { children } = props;

  return (
    <div className="cpt-text-inputs-normal">
      <div className="cpt-frame-1 cpt-border-1px-light-grey">
        <div className="cpt-text-i2755616716 cpt-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


function Frame1650(props) {
  const { textInputsNormal2Props, textInputsNormal22Props } = props;

  return (
    <div className="cpt-frame-1651">
      <TextInputsNormal22>{textInputsNormal2Props.children}</TextInputsNormal22>
      <TextInputsNormal22 className={textInputsNormal22Props.className}>
        {textInputsNormal22Props.children}
      </TextInputsNormal22>
    </div>
  );
}


function TextInputsNormal22(props) {
  const { children, className } = props;

  return (
    <div className={`cpt-text-inputs-normal-1 ${className || ""}`}>
      <div className="cpt-frame-1-1 cpt-border-1px-light-grey">
        <div className="cpt-text-i2755646716 cpt-inter-normal-sonic-silver-14px">{children}</div>
      </div>
    </div>
  );
}


function Button23(props) {
  const { children } = props;

  useEffect(() => {
    loadTimelineData(x275569TimelineData);
  }, []);

  return (
    <div className="cpt-x275569 cpt-component cpt-component-wrapper not-ready">
      <div className="cpt-master-button-9z4xaH">
        <div className="cpt-button-i275569511-mRqk0H cpt-valign-text-middle">{children}</div>
      </div>
    </div>
  );
}

const x275569TimelineData = [
  {
    initial_state_name: "Property-1=Primary",
    root_element: ".cpt-x275569",
    states_flow: {
      "Property-1=Primary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Secondary": {
        listeners: [],
        overrides: {},
      },
      "Property-1=Tertiary": {
        listeners: [],
        overrides: {},
      },
    },
  },
];


// function Footer52(props) {
//   const {
//     group85,
//     place,
//     overlapGroup,
//     vector2,
//     phone,
//     overlapGroup1,
//     vector3,
//     text15,
//     text14,
//     contactWebuildCom,
//     quickLinks,
//     aboutUs,
//     projects,
//     gallery,
//     knowledgeTransfer,
//     blogs,
//     faqs,
//     group872Props,
//   } = props;

//   return (
//     <div className="cpt-footer">
//       <div className="cpt-flex-row-1">
//         <img
//           className="cpt-vector-3"
//           src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-148@2x.svg"
//         />
//         <img className="cpt-group-85-1" src={group85} />
//         <Group872
//           facebookAppSymbolProps={group872Props.facebookAppSymbolProps}
//           facebookAppSymbolProps2={group872Props.facebookAppSymbolProps2}
//           twitterProps={group872Props.twitterProps}
//         />
//       </div>
//       <div className="cpt-flex-row-2">
//         <div className="cpt-group-32">
//           <div className="cpt-place cpt-valign-text-middle cpt-typographyheadlineh5-extrabold-20">{place}</div>
//           <div className="cpt-flex-row-3">
//             <div className="cpt-flex-col">
//               <div className="cpt-map-pin-1">
//                 <div className="cpt-overlap-group" style={{ backgroundImage: `url(${overlapGroup})` }}>
//                   <img className="cpt-vector-4" src={vector2} />
//                 </div>
//               </div>
//               <div className="cpt-phone" style={{ backgroundImage: `url(${phone})` }}></div>
//               <div className="cpt-mail">
//                 <div className="cpt-overlap-group1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
//                   <img className="cpt-vector-5" src={vector3} />
//                 </div>
//               </div>
//             </div>
//             <div className="cpt-flex-col-1">
//               <p className="cpt-text-3 cpt-typography-body-smalltext-14-regular">{text15}</p>
//               <div className="cpt-flex-col-item cpt-valign-text-middle cpt-typography-body-smalltext-14-regular">{text14}</div>
//               <div className="cpt-flex-col-item cpt-valign-text-middle cpt-typography-body-smalltext-14-regular">
//                 {contactWebuildCom}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="cpt-group-147">
//           <div className="cpt-quick-links cpt-valign-text-middle cpt-typographyheadlineh5-extrabold-20">{quickLinks}</div>
//           <div className="cpt-flex-row-4">
//             <div className="cpt-about-us cpt-valign-text-middle cpt-typographybody16-regular">{aboutUs}</div>
//             <div className="cpt-projects cpt-valign-text-middle cpt-typographybody16-regular">{projects}</div>
//           </div>
//           <div className="cpt-flex-row">
//             <div className="cpt-gallery cpt-valign-text-middle cpt-typographybody16-regular">{gallery}</div>
//             <div className="cpt-knowledge-transfer cpt-valign-text-middle cpt-typographybody16-regular">{knowledgeTransfer}</div>
//           </div>
//           <div className="cpt-flex-row">
//             <div className="cpt-blogs cpt-valign-text-middle cpt-typographybody16-regular">{blogs}</div>
//             <div className="cpt-fa-qs cpt-valign-text-middle cpt-typographybody16-regular">{faqs}</div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }


function Group872(props) {
  const { facebookAppSymbolProps, facebookAppSymbolProps2, twitterProps } = props;

  return (
    <div className="cpt-group-87">
      <FacebookAppSymbol src={facebookAppSymbolProps.src} />
      <Instagram2 overlapGroup1={facebookAppSymbolProps2.overlapGroup1} vector2={facebookAppSymbolProps2.vector2} />
      <Twitter src={twitterProps.src} />
    </div>
  );
}


function FacebookAppSymbol(props) {
  const { src } = props;

  return (
    <div className="cpt-facebook-app-symbol">
      <img className="cpt-f-1" src={src} />
    </div>
  );
}


function Instagram2(props) {
  const { overlapGroup1, vector2 } = props;

  return (
    <div className="cpt-instagram">
      <div className="cpt-overlap-group-1" style={{ backgroundImage: `url(${overlapGroup1})` }}>
        <img
          className="cpt-vector-6"
          src="https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-18@2x.svg"
        />
        <img className="cpt-vector-7" src={vector2} />
      </div>
    </div>
  );
}


function Twitter(props) {
  const { src } = props;

  return (
    <div className="cpt-twitter">
      <img className="cpt-vector-8" src={src} />
    </div>
  );
}

const whiteData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-98@2x.svg",
};

const group86Data = {
    group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-1@2x.svg",
    whiteProps: whiteData,
};

const iconMenuData = {
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
    vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-159@2x.svg",
};

const frame144Data = {
    group86Props: group86Data,
    iconMenuProps: iconMenuData,
};

const textInputsNormal20Data = {
    children: "Comment",
};

const textInputsNormal22Data = {
    children: "Name (Required)",
};

const textInputsNormal222Data = {
    children: "Email (Required)",
    className: "cpt-text-inputs-normal-2",
};

const frame1650Data = {
    textInputsNormal2Props: textInputsNormal22Data,
    textInputsNormal22Props: textInputsNormal222Data,
};

const textInputsNormal223Data = {
    children: "Phone Number  (Required)",
    className: "cpt-text-inputs-normal-3",
};

const button23Data = {
    children: "SEND MESSAGE",
};

const facebookAppSymbolData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/f-1-1@2x.svg",
};

const instagram2Data = {
    overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-154@2x.svg",
    vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-19@2x.svg",
};

const twitterData = {
    src: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-157@2x.svg",
};

const group872Data = {
    facebookAppSymbolProps: facebookAppSymbolData,
    facebookAppSymbolProps2: instagram2Data,
    twitterProps: twitterData,
};

// const footer52Data = {
//     group85: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/group-85-5@2x.svg",
//     place: "Contact",
//     overlapGroup: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-20@2x.svg",
//     vector2: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-21@2x.svg",
//     phone: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-14@2x.svg",
//     overlapGroup1: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-15@2x.svg",
//     vector3: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/vector-16@2x.svg",
//     text15: "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint.",
//     text14: "+91 8976535221, +91 8755645342",
//     contactWebuildCom: "contact@webuild.com",
//     quickLinks: "Quick Links",
//     aboutUs: "About Us",
//     projects: "Projects",
//     gallery: "Gallery",
//     knowledgeTransfer: "Knowledge Transfer",
//     blogs: "Blogs",
//     faqs: "FAQ’s",
//     group872Props: group872Data,
// };

const x10ContactUsPageTabletData = {
    contactUs: "Contact Us",
    rectangle76: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-76-4@1x.png",
    rectangle99: "https://anima-uploads.s3.amazonaws.com/projects/60c1b397ba70f9d1bdda22ff/img/rectangle-99-2@1x.png",
    sendAMessage: "Send a message",
    text112: "There are many variations of passages of Lorem Ipsum available but the majority have suffered dummy alteration in that an some form by the injected humour or randomised words which don’t look even that slightly believable. If you are Lorem Ipsums your need to be sure there isn’t anything embarrassing.",
    frame144Props: frame144Data,
    textInputsNormalProps: textInputsNormal20Data,
    frame1650Props: frame1650Data,
    textInputsNormal2Props: textInputsNormal223Data,
    button2Props: button23Data,
    //footer5Props: footer52Data,
};

